export default __webpack_public_path__ + "static/media/P50002.76941284.png";